import React, { ReactElement } from 'react';
import { PdsCard } from "@principal/design-system-react";

type TwoRowDivProps = {
    topContent?: string | ReactElement | false,
    middleContent?: string | ReactElement | false,
    bottomContent?: string | ReactElement | false,
    children?: React.ReactNode
}

const TwoRowDiv = (props: TwoRowDivProps) => {
    return (
        <PdsCard>
            <div id="top-div">
                {props.topContent}
            </div>
            {props.middleContent &&
                <div id="middle-div">
                    {props.middleContent}
                </div>
            }
            <div id="bottom-div">
                {props.bottomContent}
            </div>
        </PdsCard>
    )
};
export default TwoRowDiv;